import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DateTimePickerModule } from 'ng-pick-datetime';

import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { EventsComponent } from './components/events/events.component';
import { CamerasComponent } from './components/cameras/cameras.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { RouterModule } from '@angular/router';
import { appRoutes } from './app.routes';
import { FormsModule } from '@angular/forms';
import { AuthGuard } from './guards/auth.guard';
import { GuestGuard } from './guards/guest.guard';
import { AuthService } from './services/auth.service';
import { Http, HttpModule } from '@angular/http';
import { CameraService } from './services/camera.service';
import { EventService } from './services/event.service';
import { CameraEditComponent } from './components/camera-edit/camera-edit.component';
import { EventEditComponent } from './components/event-edit/event-edit.component';
import { InputFieldComponent } from './components/input-field/input-field.component';
import { SelectFieldComponent } from './components/select-field/select-field.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { ConfigComponent } from './components/config/config.component';
import { ConfigEditComponent } from './components/config-edit/config-edit.component';
import { ConfigService } from './services/config.service';
import { FileSelectDirective, FileUploadModule } from 'ng2-file-upload';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    EventsComponent,
    CamerasComponent,
    NavMenuComponent,
    CameraEditComponent,
    EventEditComponent,
    InputFieldComponent,
    SelectFieldComponent,
    ConfigComponent,
    ConfigEditComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes),
    FormsModule,
    HttpModule,
    DateTimePickerModule,
    MultiselectDropdownModule,
    NgbModule.forRoot(),
    FileUploadModule
  ],
  providers: [

    AuthService,
    CameraService,
    EventService,
    ConfigService,

    AuthGuard,
    GuestGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/app.module.ts